var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "price-table--feature-content-price-inner" },
      [
        _vm.getUpgradableItem(_vm.product)
          ? [
              _c(
                "div",
                { staticClass: "price-table--feature-content-price-title" },
                [
                  _c("span", [_vm._v("€")]),
                  _vm._v(
                    _vm._s(
                      _vm.formatPrice(
                        _vm.getUpgradableItem(_vm.product)
                          .netAmountToPayFormatted
                      )
                    ) + "\n\t\t\t"
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "price-table--feature-content-price-info mb-3" },
                [_vm._v("\n\t\t\t\tUpgrade-Preis\n\t\t\t")]
              )
            ]
          : _vm._e(),
        _vm._v(" "),
        !_vm.getUpgradableItem(_vm.product)
          ? _c(
              "div",
              { staticClass: "price-table--feature-content-price-title" },
              [
                _c("span", [_vm._v("€")]),
                _vm._v(
                  _vm._s(_vm.formatPrice(_vm.product.netAmountFormatted)) +
                    "\n\t\t"
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.getUpgradableItem(_vm.product)
          ? _c(
              "div",
              { staticClass: "price-table--feature-content-price-info" },
              [
                _c("div", [_vm._v("Monatliche Verlängerung:")]),
                _vm._v(" "),
                _c("div", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm._f("moneyAmount")(_vm.product.netAmountFormatted)
                      )
                    )
                  ])
                ])
              ]
            )
          : _c(
              "div",
              { staticClass: "price-table--feature-content-price-info" },
              [
                _vm._v("\n\t\t\tpro Monat."),
                _c("br"),
                _vm._v("Jederzeit kündbar.\n\t\t")
              ]
            )
      ],
      2
    ),
    _vm._v(" "),
    _vm.customButtonClickHandler || !_vm.isLoggedIn
      ? _c(
          "div",
          { staticClass: "price-table--feature-content-price-button" },
          [
            _c(
              "div",
              { staticClass: "price-table--feature-content-price-buy" },
              [
                _vm.customersCurrentProductId === _vm.product.id
                  ? [_vm._v("\n\t\t\t\tAktuell\n\t\t\t")]
                  : _vm._e(),
                _vm._v(" "),
                _vm.chosenProduct && _vm.chosenProduct.id === _vm.product.id
                  ? [
                      _c("Icon", {
                        attrs: { icon: "checkmark", color: "green" }
                      })
                    ]
                  : _vm.authLoaded && _vm.isShowBuyButton(_vm.product)
                  ? [
                      _c("Button", {
                        attrs: { text: _vm.buyButtonText },
                        on: {
                          click: function($event) {
                            return _vm.handleButtonClick(_vm.product)
                          }
                        }
                      })
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }